export default {
  namespaced: true,
  state: {
    activeOpponentSlide: 0,
    activeOpponentProfileSlide: 0,
    backgroundFlareState: { red: true, blue: true },
    opponentSelectionProgress: 0,
    faceCalibrationComplete: false,
    backgroundMusicState: true,
    audioEnabled: true,
    pageIsVisible: true,
    loading: false
  },
  getters: {
    muted (state) {
      return !state.audioEnabled || !state.pageIsVisible
    }
  },
  mutations: {
    setActiveOpponentSlide (state, value) {
      state.activeOpponentSlide = value
    },
    setActiveOpponentProfileSlide (state, value) {
      state.activeOpponentProfileSlide = value
    },
    setBackgroundFlareState (state, value) {
      state.backgroundFlareState = value
    },
    setOpponentSelectionProgress (state, value) {
      state.opponentSelectionProgress = value
    },
    setFaceCalibrationComplete (state, value) {
      state.faceCalibrationComplete = value
    },
    setBackgroundMusicState (state, value) {
      state.backgroundMusicState = value
    },
    setAudioEnabled (state, value) {
      state.audioEnabled = value
    },
    setPageIsVisible (state, value) {
      state.pageIsVisible = value
    },
    setLoading (state, value) {
      state.loading = value
    }
  }
}
